import { LAYOUTS, ModalAlignmentEnum, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { AspectRatioToken, BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { isMobile } from '../../configs/utils';
import { ACTION } from './types';
import { CloseInvite, CopyLink, InviteViaWhatsapp } from './actions';
import { heightMap } from "../../configs/height";
import { StoreKey } from "../../configs/api";
import { initializeFirebase } from "../../configs/config";
import SharedPropsService from "../../SharedPropsService";
const _isMobile = isMobile();
export const template = async (responseInvestorLink, _title, _headerTitle, _removeBanner, partnerAccountType, _bannerTitle, partnerInterestRate, customer, currentActiveTabIndex, filterObj, numberOfFilterApplied, routeId, currentPendingCustomerActiveTabIndex, currentPage, searchContext) => ({
    layout: {
        id: ROUTE.INVITE_CLIENT,
        type: LAYOUTS.MODAL,
        style: _isMobile ? {
            isPartnerPlatform: true,
            height: heightMap[ROUTE.INVITE_CLIENT]
        } : {
            //@ts-ignore
            isPartnerPlatform: true,
            alignment: ModalAlignmentEnum.CENTER,
        },
        widgets: [{ id: 'inviteClientContainer', type: WIDGET.STACK }],
    },
    datastore: {
        inviteClientContainer: {
            type: StackType.column,
            width: StackWidth.CONTENT,
            maxWidth: _isMobile ? 1024 : 508,
            padding: {
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXL,
                right: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXL,
                top: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXL,
                bottom: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXL,
            },
            widgetItems: [
                { id: 'inviteClientHeader', type: WIDGET.STACK },
                { id: 'inviteClientSpace0', type: WIDGET.SPACE },
                { id: 'inviteClientReferralStackParent', type: WIDGET.STACK },
            ],
        },
        inviteClientHeader: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: 'inviteClientT1', type: WIDGET.TEXT },
                { id: 'inviteClientCloseStack', type: WIDGET.STACK }
            ]
        },
        inviteClientCloseStack: {
            type: StackType.row,
            padding: {
                all: _isMobile ? SizeTypeTokens.MD : SizeTypeTokens.MD
            },
            bgColor: _isMobile ? ColorTokens.Grey_Chalk : ColorTokens.Grey_Chalk,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR5
            },
            widgetItems: [
                {
                    id: 'CloseIcon', type: WIDGET.ICON
                }
            ],
            action: {
                routeId: ROUTE.INVITE_CLIENT,
                type: ACTION.CLOSE_INVITE_MODAL,
                payload: { currentActiveTabIndex, filterObj, numberOfFilterApplied, routeId, currentPendingCustomerActiveTabIndex, currentPage, searchContext }
            }
        },
        CloseIcon: {
            name: IconTokens.Cross,
            color: ColorTokens.Grey_Charcoal,
            size: IconSizeTokens.MD
        },
        inviteClientReferralStackParent: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            bgColor: ColorTokens.Primary_05,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
            },
            padding: {
                all: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXL
            },
            widgetItems: [
                { id: 'inviteClientReferralStackParentT1', type: WIDGET.TEXT },
                { id: 'inviteClientReferralStackSpace0', type: WIDGET.SPACE },
                { id: 'inviteClientReferralStack', type: WIDGET.STACK },
                { id: 'inviteClientSpace1', type: WIDGET.SPACE },
                _removeBanner ? {} : { id: 'partnerJoinedStackMob', type: WIDGET.STACK },
            ],
        },
        inviteClientReferralStackParentT1: {
            label: _title ? _title : `Share the link directly with your customer, through a WhatsApp group, or publicly.`,
            fontWeight: '500',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            lineHeight: 24,
            numberOfLines: 2
        },
        partnerJoinedStackMob: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            bgColor: ColorTokens.Yellow_10,
            borderConfig: {
                borderColor: ColorTokens.Orange_200,
                borderRadius: BorderRadiusTokens.BR1,
                borderWidth: {
                    all: SizeTypeTokens.Size1,
                },
            },
            padding: {
                top: SizeTypeTokens.MD,
                bottom: SizeTypeTokens.MD,
                left: SizeTypeTokens.MD,
                right: SizeTypeTokens.MD,
            },
            widgetItems: [
                { id: 'partnerJoinedStackMobIcon1', type: WIDGET.IMAGE },
                { id: 'partnerJoinedMobSpace0', type: WIDGET.SPACE },
                { id: 'partnerJoinedMobT1', type: WIDGET.TEXT },
            ],
        },
        partnerJoinedMobT1: {
            label: _bannerTitle ? _bannerTitle : `Your customer will be automatically linked to your account when they use this link.`,
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            lineHeight: 16,
        },
        partnerJoinedStackMobIcon1: {
            // name: IconTokens.GoldenThunder,
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/goldenThunder3x.png',
            aspectRatio: AspectRatioToken.A1_1,
            size: ImageSizeTokens.XXS,
            // size: IconSizeTokens.MD,
        },
        inviteClientReferralStack: {
            type: _isMobile ? StackType.column : StackType.row,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2
            },
            widgetItems: [
                { id: 'inviteClientReferralContainer', type: WIDGET.STACK },
                {
                    id: 'inviteClientReferralContainerSpace1',
                    type: WIDGET.SPACE,
                },
                { id: 'inviteClientReferralWhatsAppBtn', type: WIDGET.BUTTON },
            ],
        },
        inviteClientReferralContainer: {
            type: StackType.row,
            width: _isMobile ? StackWidth.MATCH_PARENT : StackWidth.CONTENT,
            maxWidth: _isMobile ? 1024 : 220,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
            },
            padding: {
                top: SizeTypeTokens.Size10,
                bottom: SizeTypeTokens.Size10,
                left: SizeTypeTokens.LG,
                right: SizeTypeTokens.LG,
            },
            bgColor: ColorTokens.Primary_05,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'inviteClientReferralContainerT1ScrollStack1', type: WIDGET.SCROLL_STACK },
                {
                    id: 'inviteClientReferralContainerSpace0',
                    type: WIDGET.SPACE,
                },
                {
                    id: 'inviteClientReferralContainerCopyStack',
                    type: WIDGET.STACK,
                },
            ],
        },
        inviteClientReferralContainerT1ScrollStack1: {
            width: 142,
            widgetItems: [
                { id: 'inviteClientReferralContainerT1ScrollStack2', type: WIDGET.SCROLL_STACK },
            ]
        },
        inviteClientReferralContainerT1ScrollStack2: {
            width: '100%',
            widgetItems: [
                { id: 'inviteClientReferralContainerT1', type: WIDGET.TEXT },
            ]
        },
        inviteClientReferralContainerT1: {
            label: `${responseInvestorLink ? responseInvestorLink : ''}`,
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            lineHeight: 20,
        },
        inviteClientReferralContainerCopyStack: {
            type: StackType.row,
            widgetItems: [
                { id: 'copyIcon', type: WIDGET.ICON },
                { id: 'copyText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: ROUTE.INVITE_CLIENT,
                type: ACTION.COPY_LINK,
                payload: {
                    value: responseInvestorLink
                }
            }
        },
        copyIcon: {
            name: IconTokens.Copy,
            color: ColorTokens.Primary_100,
        },
        copyText: {
            label: `Copy`,
            fontWeight: '500',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.XS,
            color: ColorTokens.Primary_100,
            lineHeight: 18,
        },
        inviteClientReferralWhatsAppBtn: {
            type: ButtonTypeTokens.MediumSoftFilled,
            label: 'Invite via Whatsapp',
            icon: {
                name: IconTokens.Whatsapp
            },
            width: _isMobile ? ButtonWidthTypeToken.FULL : ButtonWidthTypeToken.CONTENT,
            action: {
                routeId: ROUTE.INVITE_CLIENT,
                type: ACTION.INVITE_WHATSAPP,
                payload: {
                    value: responseInvestorLink,
                    interestRate: partnerInterestRate,
                    customer,
                    currentActiveTabIndex,
                }
            }
        },
        inviteClientT1: {
            label: _headerTitle ? _headerTitle : `Share unique link`,
            fontWeight: '600',
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.LG,
            color: ColorTokens.Grey_Night,
            lineHeight: 26,
        },
        inviteClientSpace0: {
            size: SizeTypeTokens.XXL,
        },
        inviteClientSpace1: {
            size: SizeTypeTokens.XXL,
        },
        inviteClientReferralContainerSpace0: {
            size: SizeTypeTokens.Size30,
        },
        inviteClientReferralContainerSpace1: {
            size: SizeTypeTokens.XL,
        },
        partnerJoinedMobSpace0: {
            size: SizeTypeTokens.SM,
        },
        inviteClientReferralStackSpace0: {
            size: SizeTypeTokens.XXL,
        },
    },
});
export const InviteClientMF = {
    onLoad: async ({ asyncStorage, ...props }, { _link, _title, _headerTitle, _removeBanner, _bannerTitle, customer, currentActiveTabIndex, filterObj, numberOfFilterApplied, routeId, currentPendingCustomerActiveTabIndex, currentPage, searchContext }) => {
        await initializeFirebase();
        const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
        const partnerAccountType = user?.linkedPartnerAccounts[0]?.partnerAccountType;
        const partnerInterestRate = await SharedPropsService.getFirebaseConfig()?.partner_interest_rate;
        if (_link && _title && _headerTitle) {
            return Promise.resolve(template(_link, _title, _headerTitle, _removeBanner, partnerAccountType, _bannerTitle, partnerInterestRate, customer, currentActiveTabIndex, filterObj, numberOfFilterApplied, routeId, currentPendingCustomerActiveTabIndex, currentPage, searchContext));
        }
        return Promise.resolve(template(_link, _title, _headerTitle, _removeBanner, partnerAccountType, "", partnerInterestRate, customer, currentActiveTabIndex, filterObj, numberOfFilterApplied, routeId, currentPendingCustomerActiveTabIndex, currentPage, searchContext));
    },
    actions: {
        [ACTION.INVITE_WHATSAPP]: InviteViaWhatsapp,
        [ACTION.COPY_LINK]: CopyLink,
        [ACTION.CLOSE_INVITE_MODAL]: CloseInvite
    },
};
